import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import tarifUpahService from "../../../services/ref/tarifUpahService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tarif_upah: false,
    data_tarif_upah: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataTarifUpah = createAsyncThunk('tarif_upah/data',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifUpahService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('tarif_upah/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifUpahService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('tarif_upah/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifUpahService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('tarif_upah/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifUpahService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const tarifUpahSlice = createSlice({
    name: 'tarif_upah',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tarif_upah = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTarifUpah.fulfilled, (state, action) => {
                state.loading_tarif_upah = false
                state.data_tarif_upah = action.payload??[]
            })
            .addCase(getDataTarifUpah.pending, (state) => {
                state.loading_tarif_upah = true
            })
            .addCase(getDataTarifUpah.rejected, (state, action) => {
                state.loading_tarif_upah = false
                state.data_tarif_upah = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_tarif_upah = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_tarif_upah = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_tarif_upah = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = tarifUpahSlice.actions

export default tarifUpahSlice.reducer
